<template>
  <v-row>
    <v-col>
      <v-textarea
        label="Text"
        hint="Obligatorisk"
        persistent-hint
        outlined
        v-model="model"
        :rules="[required]"
        :disabled="readonly"
      ></v-textarea>
    </v-col>
  </v-row>
</template>

<script>
import { required } from '@/common/validationRules'
import { sync } from 'vuex-pathify'

export default {
  name: 'TibBannerTextInput',

  props: {
    readonly: Boolean
  },

  data() {
    return { required }
  },

  computed: {
    model: sync('tibBanner/model@text')
  }
}
</script>
